import type { FC, ReactNode } from 'react';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  podContextMenu: {
    $nest: {
      '.pod-menu-item': {
        marginBottom: 8,
        textAlign: 'left',
      },
    },
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 0,
    width: 200,
  },
});

export const SidebarMenu: FC<{
  children?: ReactNode;
}> = ({ children }) => <div className={css.podContextMenu}>{children}</div>;
